{
  "app_product.length.one_month": "1個月方案",
  "app_product.length.one_year": "年度方案",
  "fullscreendropzone.label": "拖放相片、影片到這裡",
  "fullscreendropzone.chooseFileButton": "選擇檔案",
  "uploadfilearea.selectedCount": "{selected} / {all}個選擇中",
  "uploadfilearea.selectButton": "選擇全部",
  "uploadfilearea.deselectButton": "解除全選",
  "loginarea.title": "登入",
  "loginarea.accountRequired.title": "尚未登錄電子信箱的用戶",
  "loginarea.accountRequired": "登入需要登錄電子信箱、密碼。此外，尚未登錄的用戶請從家家相簿應用程式的「家族設定」選項中的「登錄電子信箱」登錄。",
  "loginarea.emailAddressPlaceholder": "電子信箱",
  "loginarea.passwordPlaceholder": "密碼",
  "loginarea.autoLoginCheckboxLabel": "下次起自動登入",
  "loginarea.loginButton": "登入",
  "loginarea.forgottenPassword": "忘記密碼{link}",
  "loginarea.forgottenPasswordLinkText": "請點這裡",
  "loginotparea.title": "請輸入認證碼",
  "loginotparea.description": "請輸入傳送至登錄的電子信箱的認證碼",
  "loginotparea.submit": "傳送",
  "loginotparea.recreate": "再次傳送認證碼",
  "uploaderappbar.onesAlbum": "{name}的相簿",
  "uploaderappbar.logout": "登出",
  "uploaderappbar.premium": "白金會員Family",
  "uploaderappbar.premiumPro": "白金會員Family Pro",
  "uploadprogressdialog.title.uploading": "透過「{audienceType}」上傳中 - 還剩下{remaining}個",
  "uploadprogressdialog.title.uploading.description": "※僅可上傳10分鐘以內的影片",
  "uploadprogressdialog.title.uploaded": "{numUploaded}個已上傳完成",
  "uploadprogressdialog.title.uploaded.description": "可在應用程式版內確認已上傳的相片和影片。{br}至反映為止可能需要一些時間。",
  "uploadprogressdialog.cancel": "取消上傳",
  "uploadprogressdialog.done": "關閉",
  "cancelcompletedialog.body": "已取消上傳",
  "audienceType.owners_only": "僅限管理員",
  "audienceType.family": "向全體家族公開",
  "uploadbuttons.owners_only": "僅限管理員",
  "uploadbuttons.owner.family": "向全體家族公開",
  "uploadbuttons.follower.family": "新增至相簿",
  "disableuploadmodal.noAlbum": "找不到此相簿。欲再次加入，請接受來自爸爸或媽媽的邀請後重新啟用。",
  "disableuploadmodal.notAllowedFollowerUpload": "上傳功能關閉中。由此相簿的爸爸或媽媽變更設定後即可上傳。",
  "disableuploadmodal.notPremiumOwner": "註冊家家相簿白金會員即可使用。",
  "disableuploadmodal.notPremiumFollower": "註冊家家相簿白金會員即可使用。只有此相簿的爸爸或媽媽可註冊白金會員。",
  "fileGridListTile.error.tooLongVideo": "影片長度上限為10分鐘",
  "fileGridListTile.error.tooLargeVideo": "影片檔案大小上限為5GB",
  "fileGridListTile.error.tooLargeImage": "相片檔案大小上限為200MB",
  "fileGridListTile.error.unsupportedVideo": "影片檔案格式請使用MP4／MOV／QT／3GP／M4V／MTS",
  "fileGridListTile.error.unsupportedImage": "相片檔案格式請使用JPG／GIF／PNG／HEIF／HEIC",
  "customAudienceTypeButton.title": "請選擇公開成員",
  "customAudienceTypeButton.description": "可建立公開範圍並向特定成員公開相片、影片。{br}請從應用程式版建立公共範圍。",
  "fullscreenmodal.notSupportedBrowser.title": "不支援此瀏覽器。",
  "fullscreenmodal.notSupportedBrowser.body": "請將Google Chrome升級至最新版本再使用。",
  "subscriptionItem.contractStatus.cancelled.message": "已於{platform}取消完畢",
  "subscriptionItem.contractStatus.cancelled.noPlatform": "已取消",
  "subscriptionActions.scheduled.cancelDialog.title": "您想取消預約嗎？",
  "subscriptionActions.scheduled.cancelDialog.description": "只要取消預約就會續用目前的方案。",
  "subscriptionActions.scheduled.cancelDialog.cancelButton": "取消預約",
  "subscriptionActions.scheduled.cancelDialog.closeButton": "關閉",
  "premiumSubscriptionTemplate.cancelled.isAppPurchase.message": "已完成應用程式付款取消手續。如需繼續使用白金會員功能，請選用網頁支付。",
  "premiumSubscriptionTemplate.cancelled.isAppPurchase.button.title": "開始使用網頁支付",
  "premiumPlan.title": "選擇方案",
  "premiumPlan.defaultAppealText": "如果使用網頁支付全年最多可節省{number}%！",
  "premiumPlan.campaignAppealText": "期間限定優惠活動中！",
  "premiumPlan.confirmButton": "選擇此方案往下一步",
  "premiumPlan.backButton": "返回",
  "premiumPlan.premiumOneNote": "※白金會員One，僅能從家家相簿應用程式內購買。",
  "planSelection.premiumPro.title": "白金會員Family Pro",
  "planSelection.premiumPro.description": "能盡情享受的推薦方案",
  "planSelection.premium.title": "白金會員Family",
  "planSelection.premium.description": "全體家族都能享有的人氣方案",
  "planCard.yearlyPlan": "年度方案",
  "planCard.monthlyPlan": "1個月方案",
  "planCard.perMonth": "/月",
  "planCard.perYear": "/年",
  "planCard.subscribed": "已註冊",
  "planCard.monthlyEquivalent": "每月",
  "premiumPlansAlbums.confirmAlbumAndPlan": "確認對象的相簿和方案",
  "premiumPlansAlbums.targetAlbum": "對象的相簿",
  "premiumPlansAlbums.albumLabel": "{albumName}的相簿",
  "premiumPlansAlbums.pulldown.desctiption.owner": "以管理員身份參加中",
  "premiumPlansAlbums.webPaymentDiscount": "如果使用網頁支付全年最多可節省{number}%！",
  "premiumPlansAlbums.freeTrialButton": "初次限定{months}個月免費",
  "premiumPlansAlbums.cancelAnytime": "隨時可以取消",
  "premiumPlansAlbums.otherUserSubscribingMessage": "此相簿已由{userName}註冊",
  "premiumPlansAlbums.otherAlbumInAppSubscriptionMessage": "由於您已註冊其他相簿，因此無法註冊本相簿",
  "premiumPlansAlbums.proceedToPayment": "前往付款",
  "premiumPlanChange.title": "變更方案",
  "premiumPlanChange.confirmButton": "選擇此方案",
  "premiumPlanChange.backButton": "返回",
  "premiumSubscriptionTemplate.scheduled.currentPlan.title": "目前方案",
  "premiumSubscriptionTemplate.scheduled.schedulePlan.title": "預約變更的方案",
  "premiumSubscription.title": "註冊中的方案",
  "premiumSubscription.multipleSubscriptions.warning.title": "【重要】重複購買家家相簿白金會員",
  "premiumSubscription.multipleSubscriptions.warning.message": "您已透過應用程式商店註冊白金會員。需要請您自行從 App Store 或 Google Play 商店解約。",
  "premiumSubscription.multipleSubscriptions.warning.cancelLink": "解約方法在這裡",
  "premiumSubscription.empty.message": "目前沒有註冊中的方案",
  "premiumSubscription.empty.startButton": "開始使用家家相簿白金會員",
  "premiumSubscription.updateInProgress": "正在自動更新方案。\n請稍等約1小時。",
  "premiumSubscription.switchToWeb.warning.title": "【重要】切換至網頁支付的步驟",
  "premiumSubscription.switchToWeb.warning.message": "為防止重複收費，請務必執行以下操作。",
  "premiumSubscription.switchToWeb.warning.step1": "請在上述「更新日」的24小時前透過應用程式商店完成解約手續",
  "premiumSubscription.switchToWeb.warning.step1.link": "解約方法在這裡",
  "premiumSubscription.switchToWeb.warning.step2": "切換至網頁支付",
  "premiumSubscription.switchToWeb.warning.note": "您所設定的內容，將自下次更新日起為您切換。",
  "premiumSubscription.cancelled.warning": "白金會員功能即將無法使用",
  "premiumSubscription.cancelled.appPurchase.message": "取消手續已完成。如需繼續使用，請在家家相簿應用程式中再次註冊。",
  "premiumSubscription.cancelled.webPurchase.message": "取消手續已完成。如需繼續使用，請透過以下按鈕再次註冊。",
  "premiumSubscription.cancelled.webDiscount": "如果使用網頁支付全年最多可節省{number}%！",
  "premiumPaymentTemplate.appToWebPayment.newPlanStartsDate": "使用開始日期",
  "premiumPaymentTemplate.appToWebPayment.newPlanPaymentDate": "付款日期",
  "premiumPaymentTemplate.appToWebPayment.newPlanStartsImmediate": "確認後立即生效",
  "premiumPaymentTemplate.appToWebPayment.description": "您在使用應用程式付款的方案期間還剩餘{days}天。因此，這次註冊的方案在<b>{days}天內不會產生費用，</b>從{date}開始會透過網頁支付進行付款。",
  "premiumPaymentTemplate.albumTitle": "{albumName}的相簿",
  "premiumPaymentTemplate.tokushohoInfo.accordionTitle": "使用開始日 / 付款 / 解約相關事項",
  "premiumPaymentTemplate.tokushohoInfo.1": "家家相簿白金會員的特典在註冊後即可使用。",
  "premiumPaymentTemplate.tokushohoInfo.2": "將會以每1個月（單月方案）或每年（年度方案）自動更新。",
  "premiumPaymentTemplate.tokushohoInfo.3": "自動更新時，將使用您登錄的付款方式支付。",
  "premiumPaymentTemplate.tokushohoInfo.4": "若您未在免費試用期截止的24小時前解約，則白金會員的期限將會自動更新，並收取費用。",
  "premiumPaymentTemplate.tokushohoInfo.5": "1本相簿只能獲得1次免費試用的機會。",
  "premiumPaymentTemplate.tokushohoInfo.6": "註冊後，家家相簿白金會員的管理及解約相關事項，可在應用程式內的白金會員頁面進行。",
  "premiumPaymentTemplate.tokushohoInfo.7": "您可以隨時解約。",
  "premiumPaymentTemplate.tokushohoInfo.8": "即使解約，在有效期間內仍可享有特典。不會退還已支付的費用。",
  "premiumPaymentTemplate.backButton": "返回",
  "webPaymentCampaign.freeTrialExtension.appear.text": "期間限定優惠活動中！",
  "webPaymentCampaign.appear.longText": "期間限定優惠活動中！\n現在使用網頁支付更划算！",
  "webPaymentCampaign.freeTrialExtension.button": "開始免費試用2個月",
  "webPaymentCampaign.freeTrialExtension.note": "※付款開始日期及其他詳情可於下一個畫面確認。",
  "webPaymentCampaign.discount.appear.text": "期間限定優惠活動中！",
  "webPaymentCampaign.discount.note": "※優惠券將在下一個畫面上自動套用。您也可以在下一個畫面上查看實際付款金額。優惠券僅適用於下一次續訂，此後將以正常價格收費。",
  "subscriptionScheduleItem.renewalDate": "更新日期：",
  "subscriptionItem.planName.premiumFamily": "白金會員Family",
  "subscriptionItem.planName.premiumFamilyPro": "白金會員Family Pro",
  "subscriptionItem.planName.premiumUser": "白金會員One",
  "subscriptionItem.expired": "目前沒有註冊中的方案",
  "subscriptionItem.renewalDate": "更新日期：",
  "subscriptionItem.expiryDate": "有效期限：",
  "subscriptionItem.webDiscount": "如果使用網頁支付全年最多可節省{number}%！",
  "subscriptionItem.switchToWeb": "切換至網頁支付",
  "subscriptionActions.changePlan": "變更方案",
  "subscriptionActions.managePlan": "註冊管理",
  "subscriptionActions.cancelSchedule": "取消預約",
  "subscriptionActions.cancelScheduleConfirmTitle": "您想取消預約嗎？",
  "subscriptionActions.cancelScheduleConfirmBody": "只要取消預約就會續用目前的方案。",
  "premiumPlanConfirm.title": "確認更新內容",
  "premiumPlanConfirm.targetAlbum": "對象的相簿",
  "premiumPlanConfirm.albumName": "{albumName}的相簿",
  "premiumPlanConfirm.newPlan": "變更後的方案",
  "premiumPlanConfirm.newPlanPrice": "新方案的價格",
  "premiumPlanConfirm.planChangeDate": "方案變更日期",
  "premiumPlanConfirm.immediately": "確認後立即生效",
  "premiumPlanConfirm.termsDescription": "從上述的「方案變更日」起，將切換方案並完成支付。會根據變更前方案的未使用日數平均計算，支付至變更後方案的不足差額。若差額有餘，則會用於未來的費用支付。方案將自動更新為每月一次（適用於1個月方案）或每年一次（適用於年度方案）。自動更新時，會使用您登錄的支付方法完成支付。若未於下一次更新日的24小時前取消則會自動更新並支付費用。註冊後，家家相簿白金會員的管理和解約可通過應用程式內的白金會員頁面進行。可隨時解約，即使解約，在有效期間內仍可享有特典。已支付的費用恕不退還。",
  "premiumPlanConfirm.confirmButton": "確定",
  "premiumPlanConfirm.backButton": "返回",
  "premiumPaymentConfirmation.title": "註冊已完成！",
  "premiumPaymentConfirmation.appStoreWarningTitle": "【重要】致也在應用程式商店註冊中的用戶",
  "premiumPaymentConfirmation.appStoreWarningText": "若也透過應用程式商店註冊時，會發生雙重收費。您需要自行取消應用程式端的註冊。",
  "premiumPaymentConfirmation.cancelHelpLink": "解約方法在這裡",
  "premiumPaymentConfirmation.planReflectionNote": "※反應方案可能需要一些時間。",
  "premiumPaymentConfirmation.subscriptionDetailLink": "註冊方案詳情",
  "premiumPaymentConfirmation.enjoyAppButton": "馬上來享受應用程式✨",
  "premiumPaymentConfirmation.enjoyText": "馬上來享受家家相簿白金會員✨",
  "premiumPaymentUnableToSubscribe.openAppButton": "打開應用程式",
  "premiumPaymentError.title": "發生錯誤",
  "premiumPaymentError.incompleteContract": "註冊尚未完成",
  "premiumPaymentError.cardError": "信用卡情報有問題。請確認信用卡情報並再次選擇方案註冊。",
  "premiumPaymentError.systemError": "請稍後再度嘗試。",
  "premiumPaymentError.checkCardInfo": "確認信用卡情報",
  "premiumPaymentError.contactSupport": "問題未解決時，請透過家家相簿應用程式中「家族設定」選項內的「諮詢」聯繫我們。",
  "premiumPlansAlbums.appPrice.premium.monthly": "NT$110",
  "premiumPlansAlbums.appPrice.premium.yearly": "NT$1,100",
  "premiumPlansAlbums.appPrice.pro.monthly": "NT$250",
  "premiumPlansAlbums.appPrice.pro.yearly": "NT$2,500",
  "subscriptionItem.contractStatus.device.web": "透過網站註冊中",
  "subscriptionItem.contractStatus.device.app": "以{device}註冊中",
  "follower.printsPromo.daysLeft": "日",
  "followerStore.photobook.creation.learnMore": "查看詳情",
  "followerStore.photobook.details.size": "尺寸",
  "followerStore.photobook.details.thickness": "厚度",
  "followerStore.photobook.landing.classicSoftcover": "輕型平裝本",
  "followerStore.photobook.landing.premiumOneShippingNote": "※白金會員One不適用於免運費",
  "followerStore.photobook.landing.premiumSoftcover": "標準平裝本",
  "followerStore.photobook.landing.typeClassicSoftcover": "輕型平裝本",
  "followerStore.photobook.landing.typeStandard": "標準平裝本",
  "followerStore.photobook.meta.classicSoftcover.binding": "平裝本",
  "followerStore.photobook.meta.premiumSoftcover.binding": "平裝本",
  "followerStore.store.ourRecommendations": "推薦",
  "followerStore.store.photobookTitle": "實體相簿",
  "followerStore.store.viewAll": "觀看全部"
}
